import wixLocation from 'wix-location';
import wixWindow from 'wix-window';

$w.onReady(function () {

 setTimeout(function () {

  if(wixWindow.formFactor === "Mobile"){
     wixLocation.to('https://www.secure-hotel-booking.com/miramar-boutique-hotel/24G1/en-US/dateselection?sid=7e5d00b8-4601-4f17-ac51-a03da6fbb533');        
   }
 }, 1000);

});